export default "__VITE_ASSET__33963998__"